import { Box, Skeleton } from "@mui/material";
import React from "react";
import useSWR from "swr";
import { useParams } from "react-router";

import { fetcherGetToken } from "../../../services/fetcher";
import { useDispatch, useSelector } from "react-redux";
import {
  getSettingState,
  setTableModal,
} from "../../../redux/features/settingSlice";

const TableImage = () => {
  const params = useParams();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const { tableModal } = useSelector(getSettingState);
  const dispatch = useDispatch();

  const { data: about, isLoading } = useSWR(
    [`${process.env.REACT_APP_API}/content/table/${params.tableId}/`, tokenStorage],
    fetcherGetToken
  );

  return (
    <Box
      sx={{ display: "inline-flex" }}
      onClick={() => {
        dispatch(setTableModal(!tableModal));
      }}
    >
      {(isLoading || !about) && (
        <Skeleton
          className='w-100'
          variant='rectangular'
          width='100%'
          height='400px'
          style={{ zIndex: 1 }}
        />
      )}
      {!isLoading && about && (
        <img
          id='image-board'
          src={about.banner}
          alt={about.title}
          width='100%'
          height='auto'
          draggable='false'
          style={{
            zIndex: 1,
            filter: `blur(${tableModal ? "2px" : "0px"})`,
            transition: ".8s ease-in-out",
          }}
        />
      )}
    </Box>
  );
};

export default TableImage;
